export const styles = {
  label: 'tw-block tw-text-sm tw-font-medium tw-text-neutral-500 tw-mb-1',
  value: 'tw-text-neutral-900',
};
